import styled from '@emotion/styled';
import { Buttons, Message } from '../../../common/TwoButtonModal/TwoButtonModal.styles';
import rem from '../../../utils/rem/rem';

export const EditCell = styled.span`
  display: flex;
  align-items: center;
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: ${rem(14)};
`;

export const IconButton = styled.button`
  border: none;
  background-color: transparent;
  margin-left: 4px;
`;

export const CellTextWrapper = styled.span`
  width: ${rem(250)};
`;

export const WarningWrapper = styled.span`
width: ${rem(250)};
  display: flex;
  align-items: center;
`;

export const StyledInputs = styled.div`
  padding-bottom: ${rem(14)};
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
  padding-bottom: ${rem(12)};

  div {
    width: ${rem(191)};
  }
`;

export const DropdownWrapper = styled.div`
  padding: ${rem(10)} ${rem(0)};
  width: ${rem(320)};
`;

export const StyledMessage = styled(Message)`
  margin-bottom: ${rem(24)};
`;

export const StyledButtons = styled(Buttons)`
  margin-top: ${rem(32)};
`;